// extracted by mini-css-extract-plugin
module.exports = {"title":"lawsuit-subjects_title__roBQn"};